import { render, staticRenderFns } from "./jsq.vue?vue&type=template&id=28fb8bdc&scoped=true&"
import script from "./jsq.vue?vue&type=script&lang=js&"
export * from "./jsq.vue?vue&type=script&lang=js&"
import style0 from "./jsq.vue?vue&type=style&index=0&id=28fb8bdc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28fb8bdc",
  null
  
)

export default component.exports